export default __webpack_public_path__ + "static/media/parkedOrder.dd732642.svg";